var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('Videcam'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }